<div class="modal-box add-lead-modal" cdkDrag>
    <form class="add-lead-modal__form modal-form" [formGroup]="addLeadForm" (ngSubmit)="onSubmit()">
        <div class="modal-header add-lead-modal__header" cdkDragHandle>
            <div class="add-lead-modal__headline modal-headline">
                <span class="add-lead-modal__eyebrow modal-eyebrow">{{ 'LEAD' | translate }}</span>
                <h4 class="modal-title add-lead-modal__title modal-heading">{{ id === '' ? ('ADD_LEAD' | translate) : ('EDIT_LEAD' | translate) }}</h4>
            </div>
            <button type="button" class="add-lead-modal__close modal-close" [attr.aria-label]="'CLOSE' | translate" (click)="activeModal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <div class="modal-body add-lead-modal__body">
            <div class="add-lead-modal__sections modal-sections">
                <section class="add-lead-modal__panel modal-panel">
                    <div class="add-lead-modal__grid modal-grid">
                        <div class="add-lead-modal__pair-row">
                            <ng-container *ngIf="instance.isLastNameFirst; else firstLastNameInputs">
                                <div class="add-lead-modal__field">
                                    <label class="add-lead-modal__label" for="lastName">{{ 'LAST_NAME' | translate }}</label>
                                    <input id="lastName" type="text" class="form-control add-lead-modal__control" formControlName="lastName"
                                        [ngClass]="{ 'is-invalid': submitted && f.lastName.errors }" [placeholder]="'ENTER_LAST_NAME' | translate">
                                    <div *ngIf="submitted && f.lastName.errors" class="add-lead-modal__feedback">
                                        <div *ngIf="f.lastName.errors.required">{{ 'LAST_NAME_REQUIRED' | translate }}</div>
                                    </div>
                                </div>

                                <div class="add-lead-modal__field">
                                    <label class="add-lead-modal__label" for="firstName">{{ 'FIRST_NAME' | translate }}</label>
                                    <input id="firstName" type="text" class="form-control add-lead-modal__control" formControlName="firstName"
                                        [ngClass]="{ 'is-invalid': submitted && f.firstName.errors }" [placeholder]="'ENTER_FIRST_NAME' | translate">
                                    <div *ngIf="submitted && f.firstName.errors" class="add-lead-modal__feedback">
                                        <div *ngIf="f.firstName.errors.required">{{ 'FIRST_NAME_REQUIRED' | translate }}</div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>

                        <ng-template #firstLastNameInputs>
                            <div class="add-lead-modal__field">
                                <label class="add-lead-modal__label" for="firstName">{{ 'FIRST_NAME' | translate }}</label>
                                <input id="firstName" type="text" class="form-control add-lead-modal__control" formControlName="firstName"
                                    [ngClass]="{ 'is-invalid': submitted && f.firstName.errors }" [placeholder]="'ENTER_FIRST_NAME' | translate">
                                <div *ngIf="submitted && f.firstName.errors" class="add-lead-modal__feedback">
                                    <div *ngIf="f.firstName.errors.required">{{ 'FIRST_NAME_REQUIRED' | translate }}</div>
                                </div>
                            </div>

                            <div class="add-lead-modal__field">
                                <label class="add-lead-modal__label" for="lastName">{{ 'LAST_NAME' | translate }}</label>
                                <input id="lastName" type="text" class="form-control add-lead-modal__control" formControlName="lastName"
                                    [ngClass]="{ 'is-invalid': submitted && f.lastName.errors }" [placeholder]="'ENTER_LAST_NAME' | translate">
                                <div *ngIf="submitted && f.lastName.errors" class="add-lead-modal__feedback">
                                    <div *ngIf="f.lastName.errors.required">{{ 'LAST_NAME_REQUIRED' | translate }}</div>
                                </div>
                            </div>
                        </ng-template>

                        <div class="add-lead-modal__contact-row">
                            <div class="add-lead-modal__field">
                                <label class="add-lead-modal__label" for="email">{{ 'EMAIL' | translate }}</label>
                                <input id="email" type="text" class="form-control add-lead-modal__control" formControlName="email"
                                    [ngClass]="{ 'is-invalid': submitted && f.email.errors }" [placeholder]="'ENTER_EMAIL_ADDRESS' | translate">
                                <div *ngIf="submitted && f.email.errors" class="add-lead-modal__feedback">
                                    <div *ngIf="f.email.errors.required">{{ 'EMAIL_REQUIRED' | translate }}</div>
                                    <div *ngIf="f.email.errors.email">{{ 'EMAIL_INVALID' | translate }}</div>
                                </div>
                            </div>

                            <div class="add-lead-modal__field">
                                <label class="add-lead-modal__label" for="phone">{{ 'PHONE' | translate }}</label>
                                <input id="phone" type="tel" class="form-control add-lead-modal__control" formControlName="phone"
                                    [ngClass]="{ 'is-invalid': submitted && f.phone.errors }" [placeholder]="'ENTER_PHONE_NUMBER' | translate">
                                <div *ngIf="submitted && f.phone.errors" class="add-lead-modal__feedback">
                                    <div *ngIf="f.phone.errors.required">{{ 'PHONE_REQUIRED' | translate }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="add-lead-modal__panel modal-panel">
                    <div class="add-lead-modal__grid modal-grid">
                        <div class="add-lead-modal__field">
                            <label class="add-lead-modal__label" for="campaignId">{{ 'CAMPAIGN' | translate }}</label>
                            <ng-select id="campaignId" class="add-lead-modal__select" [ngClass]="{ 'is-invalid': submitted && f.campaignId.errors }"
                                formControlName="campaignId">
                                <ng-option *ngFor="let x of allCampaigns" [value]="x.id">{{x.name}}</ng-option>
                            </ng-select>
                            <div *ngIf="submitted && f.campaignId.errors" class="add-lead-modal__feedback">
                                <div *ngIf="f.campaignId.errors.required">{{ 'CAMPAIGN_REQUIRED' | translate }}</div>
                            </div>
                        </div>

                        <div class="add-lead-modal__pair-row">
                            <div class="add-lead-modal__field">
                                <label class="add-lead-modal__label" for="referralId">{{ 'REFERRAL_ID' | translate }}</label>
                                <input id="referralId" type="text" class="form-control add-lead-modal__control" formControlName="referralId"
                                    [ngClass]="{ 'is-invalid': submitted && f.referralId.errors }" [placeholder]="'ENTER_REFERRAL_ID' | translate">
                                <div *ngIf="submitted && f.referralId.errors" class="add-lead-modal__feedback">
                                    <div *ngIf="f.referralId.errors.required">{{ 'REFERRAL_ID_REQUIRED' | translate }}</div>
                                </div>
                            </div>

                            <div class="add-lead-modal__field">
                                <label class="add-lead-modal__label" for="referralSource">{{ 'REFERRAL_SOURCE' | translate }}</label>
                                <input id="referralSource" type="text" class="form-control add-lead-modal__control" formControlName="referralSource"
                                    [ngClass]="{ 'is-invalid': submitted && f.referralSource.errors }" [placeholder]="'ENTER_REFERRAL_SOURCE' | translate">
                                <div *ngIf="submitted && f.referralSource.errors" class="add-lead-modal__feedback">
                                    <div *ngIf="f.referralSource.errors.required">{{ 'REFERRAL_SOURCE_REQUIRED' | translate }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>

        <div class="modal-footer add-lead-modal__footer" cdkDragHandle>
            <div class="add-lead-modal__actions modal-actions">
                <button type="button" class="red-outline-button add-lead-modal__button modal-button" (click)="activeModal.close('Close click')">{{ 'CANCEL' | translate }}</button>
                <button type="submit" class="blue-button add-lead-modal__button modal-button">{{ 'SAVE' | translate }}</button>
            </div>
        </div>
    </form>
</div>
